import { OperatorRolesApi } from './permission-api-client/api/operator-roles-api';
import { initializePermissionApi } from './utils';

// Dedicated API client for Operator Users & Groups domain
export const operatorRolesApi = initializePermissionApi(OperatorRolesApi);
